import { withInstall } from "../../utils/install";
import MonitorPlayback from "./src/monitor-playback.vue";

export const IMonitorPlayback = withInstall(MonitorPlayback); // 增加类型

export default IMonitorPlayback;
